import { cn } from '@/lib/cn';
import { type InputHTMLAttributes, forwardRef } from 'react';

type Props = InputHTMLAttributes<HTMLInputElement>;

export const Input = forwardRef<HTMLInputElement, Props>(function Input(
  { className, ...props },
  ref
) {
  return (
    <input
      ref={ref}
      className={cn(
        'h-10 w-full rounded-[var(--fv-radius)] border border-[var(--fv-border)] bg-[var(--fv-surface)] px-3 text-sm text-[var(--fv-text)]',
        'placeholder:text-[var(--fv-text-muted)]',
        'transition-colors hover:border-[var(--fv-primary)]/40',
        'focus:border-[var(--fv-primary)] focus:outline-none focus:ring-2 focus:ring-[var(--fv-primary)]/20',
        'disabled:cursor-not-allowed disabled:opacity-50',
        className
      )}
      {...props}
    />
  );
});
